import { ComponentDesign, ComponentDesignLayoutModel } from '@paragon/contract-library';
import { getChildrenFinder, getComponentDesignDescendantGuids } from '@paragon/layout-models';
import { notNullish } from '@paragon/utilities';

import { RootState } from '..';

export function getLumbersPanelComponentDesignTargets(
  state: RootState,
  targetGuid: string,
): (ComponentDesign | ComponentDesignLayoutModel)[] {
  const singleComponent = state.componentDesigns.data[targetGuid];
  if (singleComponent) {
    return [singleComponent];
  }

  return getComponentDesignDescendantGuids(targetGuid, getChildrenFinder(state))
    .map((componentDesignGuid) => state.componentDesigns.data[componentDesignGuid])
    .filter(notNullish);
}
